import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[aaTabTitle]',
    standalone: false
})
export class TabTitleDirective
{
    constructor(public templateRef: TemplateRef<any>) { }
}
